import {
  base_colorRaisedSurface,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  padding: ${spacing(9)} ${spacing(10)};
  background-color: ${base_colorRaisedSurface};
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
  border-radius: 10px;

  &.darkened {
    background-color: rgba(0, 0, 0, 0.2);
    color: ${text_colorTextSecondary};

    &:hover {
      cursor: not-allowed;
    }
  }
`
